import { render, staticRenderFns } from "./inboxHandler.vue?vue&type=template&id=a1d02a7a&scoped=true"
import script from "./inboxHandler.vue?vue&type=script&lang=js"
export * from "./inboxHandler.vue?vue&type=script&lang=js"
import style0 from "./inboxHandler.vue?vue&type=style&index=0&id=a1d02a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d02a7a",
  null
  
)

export default component.exports